<template>
  <div class="productSort">
    <form @submit.prevent="submitForm">
      <div class="header acea-row row-center-wrapper" ref="header">
        <div class="acea-row row-between-wrapper input">
          <span class="iconfont icon-sousuo"></span>
          <input type="text" placeholder="搜索商品信息" v-model="search" />
        </div>
      </div>
    </form>

    <div class="slider-banner banner">
      <swiper :options="swiperOption" v-if="banner.length > 0">
        <swiper-slide v-for="(item, index) in banner" :key="index">
          <router-link
            :to="item.wap_url ? item.wap_url : ''"
            class="search acea-row row-middle"
          >
            <img :src="item.pic" />
          </router-link>
        </swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>
    </div>

    <!--<div class="level_menu">-->
    <!--<router-link :to="{-->
    <!--path: '/integral_vip_list',-->
    <!--query: { id: item.id, title: item.name }-->
    <!--}" class="item" v-for="(item, index) in grade" :key="index">-->
    <!--<img :src="item.icon" alt="">-->
    <!--<div class="name">{{item.name}}</div>-->
    <!--</router-link>-->
    <!--</div>-->

    <div class="aside">
      <div
        class="item acea-row row-center-wrapper"
        :class="index === navActive ? 'on' : ''"
        v-for="(item, index) in category"
        :key="index"
        @click="asideTap(index)"
      >
        <span>{{ item.cate_name }}</span>
      </div>
    </div>
    <div class="conter" @scroll.native="onScroll">
      <div class="listw" v-for="(item, index) in category" :key="index">
        <div class="title acea-row row-center-wrapper" ref="title">
          <div class="line"></div>
          <div class="name">{{ item.cate_name }}</div>
          <div class="line"></div>
        </div>
        <div class="list acea-row">
          <router-link
            class="item acea-row row-column row-middle"
            v-for="(child, index) in item.children"
            :key="index"
            :to="{
              path: '/integral_list',
              query: { id: child.id, title: child.cate_name }
            }"
          >
            <div class="picture"><img :src="child.pic" /></div>
            <div class="name line1">{{ child.cate_name }}</div>
          </router-link>
        </div>
      </div>
    </div>
    <div style="height:1.2rem;"></div>
  </div>
</template>
<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "@assets/css/swiper.min.css";
import debounce from "lodash.debounce";
import { getIntegralCategory, getIntegralIndex } from "@api/store";
import { trim } from "../../utils";

export default {
  name: "GoodsClass",
  components: {
    swiper,
    swiperSlide
  },
  props: {},
  data: function() {
    return {
      category: [],
      navActive: 0,
      search: "",
      lock: false,
      banner: [],
      grade: [],

      swiperOption: {
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        },
        autoplay: {
          disableOnInteraction: false,
          delay: 2000
        },
        loop: true,
        speed: 1000,
        observer: true,
        observeParents: true
      }
    };
  },
  watch: {
    "$route.params.pid": function(n) {
      console.log(n);
      if (n) {
        this.activeCateId(n);
      }
    }
  },
  mounted: function() {
    document.addEventListener("scroll", this.onScroll, false);
    this.loadCategoryData();
  },
  methods: {
    activeCateId(n) {
      let index = 0;
      n = parseInt(n);
      if (!n) return;
      this.category.forEach((cate, i) => {
        if (cate.id === n) index = i;
      });

      if (index !== this.navActive) {
        this.asideTap(index);
      }
    },
    loadCategoryData() {
      console.log(123);
      getIntegralCategory().then(res => {
        console.log(res);
        this.category = res.data;
        // this.category =
        this.$nextTick(() => {
          if (this.$route.params.pid) this.activeCateId(this.$route.params.pid);
          else this.onScroll();
        });
      });
      getIntegralIndex().then(res => {
        console.log(res);
        this.banner = res.data.banner;
        this.grade = res.data.grade;
      });
    },
    submitForm: function() {
      var val = trim(this.search);
      if (val) {
        this.$router.push({
          path: "/goods_list",
          query: { s: val }
        });
        setTimeout(() => (this.search = ""), 500);
      }
    },
    asideTap(index) {
      const top =
        this.$refs.title[index].offsetTop -
        this.$refs.header.offsetHeight -
        window.scrollY;

      this.lock = true;

      window.scrollBy({ top, left: 0, behavior: "smooth" });
      this.navActive = index;
    },
    onScroll: debounce(function() {
      if (this.lock) {
        this.lock = false;
        return;
      }
      const headerHeight = this.$refs.header.offsetHeight,
        { scrollY } = window,
        titles = this.$refs.title;
      titles.reduce((initial, title, index) => {
        if (initial) return initial;
        const parent = title.parentNode || title.parentElement;
        if (
          scrollY + headerHeight + 15 <
          title.offsetTop + parent.offsetHeight
        ) {
          initial = true;
          this.navActive = index;
        }
        // else if (innerHeight + scrollY + 15 > offsetHeight) {
        //   this.navActive = titles.length - 1;
        //   initial = true;
        // }
        return initial;
      }, false);
    }, 500)
  },
  beforeDestroy: function() {
    document.removeEventListener("scroll", this.onScroll, false);
  }
};
</script>
<style scoped>
.productSort .aside {
  top: 4.8rem;
}
.productSort .conter {
  margin-top: 4.8rem;
}
.productSort .banner {
  height: 3.75rem;
  position: fixed;
  top: 0.96rem;
  right: 0;
  left: 0;
}
.productSort .banner img {
  width: 100%;
  height: 100%;
}
.productSort .banner .swiper-pagination {
  bottom: 0.07rem;
}
.productSort .banner .swiper-pagination-bullet {
  width: 0.2rem;
  height: 0.04rem;
  border-radius: 0.03rem;
  background-color: #fff;
  opacity: 0.6;
}
.productSort .banner .swiper-pagination-bullet-active {
  opacity: 1;
}
.level_menu {
  display: flex;
  justify-content: space-around;
  margin: 0.3rem 0.2rem 0 0.2rem;
  box-shadow: 0 0 1rem rgba(0, 0, 0, 0.2);
  border: 1px solid #e5e5e5;
  border-radius: 0.2rem;
  padding: 0.2rem 0;
}
.level_menu .item {
  text-align: center;
}
.level_menu .item img {
  width: 1rem;
  height: 1rem;
}
</style>
